import { DatePipe } from '@angular/common'
import { Component } from '@angular/core'

import { BaseComponent } from '../../shared'

interface SafetyFeedbackDashboardKpi {
    totalSubmitted: number
    submittedThisMonth: number
    submittedLast30Days: number
    positiveFeedbackCount: number
    jobsWithFeedback: number
    requiresJhaOutstanding: number
}

interface MonthlyCount {
    label: string
    count: number
}

interface OutstandingItem {
    feedbackId: string
    jobId: string
    jobName: string
    eventDateTime: string | null
}

interface RequiringJha {
    needsJhaCount: number
    inProgressCount: number
    addressedThisMonth: number
    outstanding: OutstandingItem[]
}

interface JobCount {
    jobId: string
    jobName: string
    count: number
}

interface SafetyFeedbackDashboardMetrics {
    kpi: SafetyFeedbackDashboardKpi
    monthlyCounts: MonthlyCount[]
    requiringJha: RequiringJha
    topJobs: JobCount[]
}

const emptyMetrics = (): SafetyFeedbackDashboardMetrics => ({
    kpi: {
        totalSubmitted: 0,
        submittedThisMonth: 0,
        submittedLast30Days: 0,
        positiveFeedbackCount: 0,
        jobsWithFeedback: 0,
        requiresJhaOutstanding: 0,
    },
    monthlyCounts: [],
    requiringJha: { needsJhaCount: 0, inProgressCount: 0, addressedThisMonth: 0, outstanding: [] },
    topJobs: [],
})

@Component({
    selector: 'app-safety-feedback-dashboard',
    templateUrl: './safety-feedback-dashboard.component.html',
    styleUrls: ['./safety-feedback-dashboard.component.css'],
    standalone: true,
    imports: [DatePipe],
})
export class SafetyFeedbackDashboardComponent extends BaseComponent {
    metrics: SafetyFeedbackDashboardMetrics = emptyMetrics()
    metricsLoadError = false

    constructor() {
        super()
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            'safetyFeedbackDashboard',
            true,
            this.services.data.get<SafetyFeedbackDashboardMetrics>('/api/SafetyFeedback/GetDashboardMetrics').subscribe({
                next: result => {
                    this.metrics = result ?? emptyMetrics()
                    this.metricsLoadError = false
                    this.initialLoadingComplete()
                },
                error: () => {
                    this.metrics = emptyMetrics()
                    this.metricsLoadError = true
                    this.initialLoadingComplete()
                },
            }),
        )
    }

    maxMonthlyCount(): number {
        return Math.max(...this.metrics.monthlyCounts.map(m => m.count), 1)
    }
}
